import { LocalDate } from "@flockcover/flock-svc-core-types"

export type UpdateQueryStringParams = (
  newParams: Record<string, string | number | LocalDate | null | undefined>,
  location: Location
) => void
export const updateQueryStringParams: UpdateQueryStringParams = (newParams, location) => {
  const params = new URLSearchParams(location?.search)
  Object.entries(newParams).forEach(([key, value]) => {
    if (value) {
      params.set(key, `${value}`)
    } else {
      params.delete(key)
    }
  })
  const queryString = params.toString()
  const newurl = `${location.pathname}${queryString ? `?${queryString}` : ``}`
  window.history.replaceState({}, ``, newurl)
}
